import { SvgIcon, SvgIconProps } from '@mui/material';
import { memo } from 'react';
const SvgAndroid32 = (props: SvgIconProps) => {
  const { sx, ...other } = props;
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 32 32"
      sx={{
        ...sx,
      }}
      {...other}
    >
      <defs>
        <path
          id="android-32_svg__a"
          d="M23 6a3 3 0 1 1-2.354 4.86l-9.788 5.225a3 3 0 0 1 .024 1.751l9.643 4.468a3 3 0 1 1-.42.907l-9.658-4.475a3 3 0 1 1-.048-3.538l9.766-5.213A3 3 0 0 1 23 6m0 16a2 2 0 1 0 0 4 2 2 0 0 0 0-4M8 15a2 2 0 1 0 0 4 2 2 0 0 0 0-4m15-8a2 2 0 1 0 0 4 2 2 0 0 0 0-4"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id="android-32_svg__b" fill="#fff">
          <use xlinkHref="#android-32_svg__a" />
        </mask>
        <use xlinkHref="#android-32_svg__a" fill="#000" fillRule="nonzero" />
        <g fill="#262729" mask="url(#android-32_svg__b)">
          <path d="M0 0h32v32H0z" />
        </g>
      </g>
    </SvgIcon>
  );
};
const Memo = memo(SvgAndroid32);
export default Memo;
